import { isSameDay } from 'date-fns';

import { getTenantTimeFromUTC } from '../../../helpers/date';
import { getDateObject } from '../domain/AvailabilityDate';
import { WorkCalendarRecord } from '../types';

export function isOutsideOfSelectableInterval(requestedAvailabilityDates: WorkCalendarRecord[], availabilityDate: WorkCalendarRecord, timeZone: string) {
    if (!requestedAvailabilityDates?.length) {
        return true;
    }

    const availabilityDateObj = getDateObject(availabilityDate);
    const availabilityDateTz = getTenantTimeFromUTC(availabilityDateObj, timeZone);
    const now = new Date();
    const nowTz = getTenantTimeFromUTC(now, timeZone);

    const firstRequestedDateObj = getDateObject(requestedAvailabilityDates[0]);
    const firstRequestedDateTz = getTenantTimeFromUTC(firstRequestedDateObj, timeZone);

    const latestRequestedDateObj = getDateObject(requestedAvailabilityDates[requestedAvailabilityDates.length - 1]);
    const latestRequestedDateTz = getTenantTimeFromUTC(latestRequestedDateObj, timeZone);

    const isAtLeastYesterday = availabilityDateObj.valueOf() < now.valueOf() && !isSameDay(nowTz, availabilityDateTz);
    const isAtLeastDayBeforeRequestedInterval = availabilityDateObj.valueOf() < firstRequestedDateObj.valueOf() && !isSameDay(firstRequestedDateTz, availabilityDateTz);
    const isAtLeastDayAfterRequestedInterval = availabilityDateObj.valueOf() > latestRequestedDateObj.valueOf() && !isSameDay(latestRequestedDateTz, availabilityDateTz);

    return isAtLeastDayBeforeRequestedInterval || isAtLeastYesterday || isAtLeastDayAfterRequestedInterval;
}
